export class IndirectMeetingRequest {
  MeetingSk?: string;
  formJson?: string;
  providerSk?:string;
  actualServiceDate?: string;
  actualStartTime?: string;
  actualEndTime?: string;
  constructor(data: any) {
    this.MeetingSk = data?.MeetingSk;
    this.formJson = data?.formJson;
    this.providerSk = data?.providerSk;
    this.actualServiceDate = data?.actualServiceDate;
    this.actualStartTime = data?.actualStartTime;
    this.actualEndTime = data?.actualEndTime;
  }
}
